// GenieX — Real photography pools + deterministic per-page design assignment.
// Each product/solution slug is hashed to a stable index so the same page
// always renders the same hero/benefits/use-case layout, image set and
// testimonial — while different pages land on genuinely different combinations.

const GX = "/api/admin/uploads/shop-products";

export const IMAGE_POOLS = {
  switches: [
    `${GX}/elite-touch-switch-panel.png`,
    `${GX}/retrofit-2gang.png`,
    `${GX}/retrofit-4gang.png`,
    `${GX}/elite-ac-knob.png`,
  ],
  lighting: [
    `${GX}/smart-bulb-plain.png`,
    `${GX}/rgb-smart-bulb.png`,
    `${GX}/rgb-dimmer-controller.png`,
    `${GX}/led-strip-controller.png`,
  ],
  curtains: [
    `${GX}/smart-curtain-kit.png`,
    "https://images.unsplash.com/photo-1778731660454-38133bfb3a3d?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1754611380518-61a923cc47ca?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1763939821864-93d473395499?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  lock: [
    `${GX}/door-lock-fingerprint.png`,
    `${GX}/door-lock-face-recognition.png`,
    "https://images.unsplash.com/photo-1585079374502-415f8516dcc3?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1689804847843-76c6719a79c7?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  doorbell: [
    `${GX}/smart-doorbell.png`,
    "https://images.unsplash.com/photo-1718866876977-70a816f62640?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1633194883650-df448a10d554?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1528817466667-942353411fee?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  cctv: [
    `${GX}/outdoor-camera.png`,
    "https://images.unsplash.com/photo-1589935447067-5531094415d1?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1528312635006-8ea0bc49ec63?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1618482914248-29272d021005?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  safety: [
    `${GX}/gas-leak-sensor.png`,
    `${GX}/smoke-detector.png`,
    `${GX}/smoke-sensor-alt.png`,
    `${GX}/fire-sensor.png`,
  ],
  motion: [
    `${GX}/motion-sensor.png`,
    `${GX}/motion-sensor-bulb.png`,
    "https://images.unsplash.com/photo-1695758987304-694fdcb654fa?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1771908997889-6d043c4a9ef7?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  air: [
    "https://images.unsplash.com/photo-1560184897-67f4a3f9a7fa?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1554995207-c18c203602cb?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1597665863042-47e00964d899?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1560185007-5f0bb1866cab?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  ac: [
    `${GX}/elite-ac-knob.png`,
    "https://images.unsplash.com/photo-1782729433970-abf88b005196?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1656652173501-9739078f0f4e?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1749140944972-1813e43e67af?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  tv: [
    `${GX}/universal-remote.png`,
    "https://images.unsplash.com/photo-1478802848783-2ed6e96a0462?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1593784991095-a205069470b6?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1593784991188-c899ca07263b?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  vacuum: [
    `${GX}/robot-vacuum-1.png`,
    `${GX}/robot-vacuum-2.png`,
    "https://images.unsplash.com/photo-1653990480360-31a12ce9723e?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1590164409291-450e859ccb87?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  geyser: [
    "https://images.unsplash.com/photo-1642755622684-348cf011051f?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1628602813485-4e8b09442e98?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1642755622887-6aef7cbe0725?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1643526399974-7de62b65a6f8?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  plug: [
    `${GX}/wifi-plug-black.png`,
    `${GX}/wifi-plug-white.png`,
    "https://images.unsplash.com/photo-1601467450590-8c3d11cde2fd?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1564517945244-d371c925640b?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  pet: [
    `${GX}/pet-feeder.png`,
    "https://images.unsplash.com/photo-1739804820123-d846b93fbdef?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1739804820262-2e1e7f412ceb?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1769606928775-3b90a8e5fd01?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  gate: [
    "https://images.unsplash.com/photo-1624314044202-c2139e93c665?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1645005049035-c35644b627ba?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1719773745404-d2e57e1af9bf?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1749987327471-d0dba719f46d?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  sprinkler: [
    "https://images.unsplash.com/photo-1622122123829-e0490a288d04?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1767533427586-436b683f34ef?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1718565524318-b58b8b86b813?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1770664945615-52203ab54c88?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  pool: [
    "https://images.unsplash.com/photo-1707189856923-46dd41ea2bdc?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1606917454663-343e58811bb1?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1704793027627-6b47800fc2ec?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  villa: [
    "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  theatre: [
    "https://images.unsplash.com/photo-1781274326537-0fa818da10bc?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1687773449677-2d9a4c76f66e?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1778654959480-9531f93501fb?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1759230766134-e3ff1c27d20e?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  apartment: [
    "https://images.unsplash.com/photo-1688646953306-5ec93eab8c06?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  hotel: [
    "https://images.unsplash.com/photo-1759264244726-adde4e4318fc?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1774280954999-9758f11f3d41?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1776763255122-3d35e32aee64?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1776763255197-495b343d5a33?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  family: [
    "https://images.unsplash.com/photo-1639391380085-ead79229b762?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1632661702178-c7d75a2d86e6?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1730130596425-197566414dc4?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1590370082074-a48dcac07dd1?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
  blueprint: [
    "https://images.unsplash.com/photo-1698846296220-e44d9d4b9100?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1721244654392-9c912a6eb236?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1649688066830-a0cf04d1bc41?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1721244654394-36a7bc2da288?crop=entropy&cs=srgb&fm=jpg&q=85",
  ],
};

// Maps every product + solution page slug to its photography pool.
export const CATEGORY_FOR_PAGE = {
  // Smart controls
  "dynamic-series": "switches", "smart-touch-panels": "switches", "smart-switches": "switches",
  "scene-controllers": "switches", "wireless-remotes": "switches", "retro-modules": "switches",
  // Lighting
  "smart-dimmers": "lighting", "led-strip-control": "lighting", "smart-bulbs": "lighting",
  "mood-lighting": "lighting", "color-tunable-lighting": "lighting", "outdoor-garden-lighting": "lighting",
  // Curtains & blinds
  "curtain-motors": "curtains", "roller-blinds": "curtains", "roman-blinds": "curtains",
  "venetian-blinds": "curtains", "skylight-control": "curtains",
  // Security
  "smart-locks": "lock", "video-door-phones": "doorbell", "cctv-solutions": "cctv",
  "gas-leak-detection": "safety", "smoke-sensors": "safety", "water-leak-detection": "safety",
  "panic-buttons": "safety",
  // Sensors
  "motion-sensors": "motion", "presence-sensors": "motion", "door-window-sensors": "motion",
  "temperature-sensors": "air", "air-quality-sensors": "air", "light-sensors": "air",
  // Appliances
  "ac-control": "ac", "tv-control": "tv", "robot-vacuum": "vacuum", "smart-geyser": "geyser",
  "smart-plugs": "plug", "pet-feeders": "pet",
  // Outdoor & utility
  "gate-automation": "gate", "boom-barriers": "gate", "sprinkler-automation": "sprinkler",
  "pool-control": "pool", "driveway-sensors": "gate",
  // Solutions
  "complete-home": "villa", "home-theatre": "theatre", "villas": "villa",
  "apartments": "apartment", "rental": "apartment", "hotel": "hotel",
  "smart-living": "family", "home-security": "cctv", "energy-saving": "plug",
  "elderly-friendly": "family", "child-safe": "family",
  "for-architects": "blueprint", "for-interior-designers": "blueprint",
  "for-builders": "blueprint", "for-homeowners": "family",
};

export const TESTIMONIALS = [
  { name: "Rohan Mehta", city: "Jubilee Hills, Hyderabad", quote: "GenieX didn't just fit switches — they redesigned how our home feels. Guests always ask about the glass panels first.", avatar: IMAGE_POOLS.family[0] },
  { name: "Sunitha Reddy", city: "Gachibowli, Hyderabad", quote: "The installation team was punctual, careful with our marble, and the app just works. No tech-support drama, ever.", avatar: IMAGE_POOLS.family[1] },
  { name: "Arvind & Priya", city: "Banjara Hills, Hyderabad", quote: "Our electricity bill dropped noticeably in the first month. The AC scenes alone paid for themselves.", avatar: IMAGE_POOLS.family[2] },
  { name: "Kavya Rao", city: "Vijayawada", quote: "We were nervous about a 'smart home' feeling complicated for my parents. It's the opposite — one button, done.", avatar: IMAGE_POOLS.family[3] },
  { name: "Imran Sheikh", city: "Kondapur, Hyderabad", quote: "Six months in, zero issues. The 5-year warranty made the decision easy, but the daily experience is what sold us on GenieX.", avatar: IMAGE_POOLS.family[0] },
  { name: "Lakshmi Narayanan", city: "Visakhapatnam", quote: "Every finish matched our interior designer's mood board exactly. It doesn't look like 'tech' — it looks like our home.", avatar: IMAGE_POOLS.family[1] },
  { name: "Vikram Chowdary", city: "Kokapet, Hyderabad", quote: "We upgraded room by room over a year. GenieX let us start small and never once felt like a mismatched patchwork.", avatar: IMAGE_POOLS.family[2] },
  { name: "Divya & Sandeep", city: "Guntur", quote: "The WhatsApp support is genuinely fast. We had a query at 9pm on a Sunday and got a same-night reply.", avatar: IMAGE_POOLS.family[3] },
];

export function hashSlug(input, salt = 0) {
  let h = 0;
  const s = String(input || "");
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0;
  }
  h = (h + Math.imul(salt, 0x9e3779b9)) >>> 0;
  // MurmurHash3 finalizer — full-bit avalanche so different salts decorrelate cleanly.
  h ^= h >>> 16;
  h = Math.imul(h, 0x85ebca6b) >>> 0;
  h ^= h >>> 13;
  h = Math.imul(h, 0xc2b2ae35) >>> 0;
  h ^= h >>> 16;
  return h >>> 0;
}

export function getPageImages(slug) {
  const key = CATEGORY_FOR_PAGE[slug] || "family";
  const pool = IMAGE_POOLS[key] || IMAGE_POOLS.family;
  const offset = hashSlug(slug, 0) % pool.length;
  return [...pool.slice(offset), ...pool.slice(0, offset)];
}

const HERO_VARIANTS = ["split-right", "split-left", "fullbleed", "framed"];
const BENEFITS_VARIANTS = ["cards", "bento", "spec-strip", "icon-list"];
const USECASE_VARIANTS = ["cards", "timeline", "alternating", "numbered-steps"];

export function getPageDesign(slug) {
  const heroIdx = hashSlug(slug, 101) % HERO_VARIANTS.length;
  const benefitsIdx = hashSlug(slug, 202) % BENEFITS_VARIANTS.length;
  const usecaseIdx = hashSlug(slug, 303) % USECASE_VARIANTS.length;
  const testimonialToggle = hashSlug(slug, 404) % 2 === 0;
  const testimonialIdx = hashSlug(slug, 505) % TESTIMONIALS.length;
  return {
    hero: HERO_VARIANTS[heroIdx],
    benefits: BENEFITS_VARIANTS[benefitsIdx],
    usecase: USECASE_VARIANTS[usecaseIdx],
    showTestimonial: testimonialToggle,
    testimonial: TESTIMONIALS[testimonialIdx],
  };
}
